/**
 * Processes media resource URL to ensure proper formatting.
 * Returns the URL as-is (with optional cache tag). Relative URLs stay
 * relative — same-origin `<img src>` and next/image's `url=` param both
 * accept them, and keeping them relative avoids triggering the remote-
 * URL path in next/image (which requires a remotePatterns whitelist).
 *
 * @param url The original URL from the resource
 * @param cacheTag Optional cache tag to append to the URL
 */
export const getMediaUrl = (url: string | null | undefined, cacheTag?: string | null): string => {
  if (!url) return ''

  if (cacheTag && cacheTag !== '') {
    cacheTag = encodeURIComponent(cacheTag)
  }

  // Strip localhost origin when Payload's default fs adapter prepends it.
  // Same-origin relative URLs bypass next/image's SSRF guard against private
  // IPs (which blocks http://localhost:* as an "upstream image") and avoid
  // needing a remotePatterns whitelist.
  let normalized = url
  if (url.startsWith('http://localhost:') || url.startsWith('http://127.0.0.1:')) {
    try {
      const u = new URL(url)
      normalized = u.pathname + (u.search || '')
    } catch {
      /* leave url as-is on parse failure */
    }
  }

  return cacheTag ? `${normalized}?${cacheTag}` : normalized
}
